import { render, staticRenderFns } from "./modelManager.vue?vue&type=template&id=3b828910&scoped=true&"
import script from "./modelManager.vue?vue&type=script&lang=js&"
export * from "./modelManager.vue?vue&type=script&lang=js&"
import style0 from "./modelManager.vue?vue&type=style&index=0&id=3b828910&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b828910",
  null
  
)

export default component.exports